(function(){
    angular
        .module('app')
        .directive('ngMateriaasdasdl', material);

        material.$inject = ['$timeout'];
        function material($timeout){
            return {
	            //require: 'ngModel',
	            link: function(scope, element, attrs) {
	            	$(element).materialCheckbox();
				}
        	}
        }
})();